<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-blue-400 hover:text-blue-600" href="/pricelists">Price Lists</Link>
      <span class="text-blue-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <trashed-message v-if="pricelist.deleted_at" class="mb-6" @restore="restore"> This Price List has been deleted. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
          <div class="w-full mb-4">
            <label class="form-label text-bold">Discounts</label>
            <div class="grid grid-cols-4">
              <div v-for="discount in discounts" :key="discount.id">
                <input v-model="form.discounts" type="checkbox" :value="discount.id" />
                <span class="text-sm px-2">{{ discount.value }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="! pricelist.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Price List</button>
          <loading-button :loading="form.processing" class="btn-blue ml-auto" type="submit">Update Price List</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    pricelist: Object,
    discounts: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.pricelist.name,
        discounts: this.pricelist.discounts,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/pricelists/${this.pricelist.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this Price List?')) {
        this.$inertia.delete(`/pricelists/${this.pricelist.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this Price List?')) {
        this.$inertia.put(`/pricelists/${this.pricelist.id}/restore`)
      }
    },
  },
}
</script>
